import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-delete-new',
    templateUrl: './dialog-delete-new.component.html',
    styleUrls: ['./dialog-delete-new.component.scss'],
    standalone: false
})
export class DialogDeleteNewComponent implements OnInit {
  selectedId: number | null = null;
  sizeOption: string  = 'large';
  constructor(public dialogRef: MatDialogRef<DialogDeleteNewComponent>, @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit(): void {
    if (this.data.sizeOption){
      this.sizeOption = this.data.sizeOption;
    };
  }

  closeDialog(): void {
       this.dialogRef.close();

  }

  // closeDialogWithResult(result?: any): void {
  //   console.log('Dialog closed with result:', result);
  //      this.dialogRef.close(result);
  //  }
}
